import {useSelector} from 'react-redux';


import * as i18nConstants from '../i18nConstants';

import {configSelectors} from '../../Config';


/**
 * @return {array|object}
 */
function usePlatformLanguages() {

    // to adhere non-backend use-cases (e.g. anon usage), fall back to default configuration
    const platformLanguages = useSelector(configSelectors.getPlatformLanguages);
    if (!platformLanguages) {

        return i18nConstants.PLATFORM_LOCALES;
    }

    return platformLanguages;
}


export default usePlatformLanguages;
